import React from 'react';
import ChartistGraph from 'react-chartist';
import Card from './Card';
import api from '../../../api';
import '../../../assets/css/utils.css';

var capitalize = function(str) {
  return str.replace(/(?:^|\s)\S/g, function(a) {
    return a.toUpperCase();
  });
};

const dominios = {
  artes_humanidades: 'Arte y Humanidades',
  cc_fisicas: 'Ciencias Físicas',
  ciencias_sociales: 'Ciencias Sociales',
  biologia_cc_salud: 'Biología y Ciencias de la Salud'
};

class EstadisticasColocativos extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      total: 0,
      totales: [],
      textos: []
    };
  }

  componentDidMount = () => {
    const { lema, categoria, id, corpus, clasificacion } = this.props;
    const cadena = clasificacion.replace(' + ',' ');

    api.colocaciones.getDatosCuantitativos(lema,categoria,cadena).then(resultadosDC => {
    //api.colocaciones.getDatosCuantitativos(lema,categoria).then(resultadosDC => {

      if (typeof resultadosDC !== 'undefined') {
        if (
          resultadosDC.length > 0
        ) {
          this.setState({            
            totales: resultadosDC,
            total: resultadosDC[0].freq
          });
        }
      }
    });
    api.colocaciones.getTextosColocativos(this.props.corpus).then(resultadosTC => this.setState({ textos: resultadosTC }));
  }

  crearInformacionDominio(dominios) {
    let totalDominios = [];

    this.state.totales.map(dato => {       
        if(dato.artes_humanidades > 0) totalDominios.push(<span>
          <strong> {dominios.artes_humanidades}: </strong>
          {dato.artes_humanidades} apariciones ({(dato.artes_humanidades*100/dato.freq).toFixed(2)}%) | 
        </span>);
        if(dato.cc_fisicas > 0) totalDominios.push(<span>
          <strong> {dominios.cc_fisicas}: </strong>
          {dato.cc_fisicas} apariciones ({(dato.cc_fisicas*100/dato.freq).toFixed(2)}%) | 
        </span>);
        if(dato.ciencias_sociales > 0) totalDominios.push(<span>
          <strong> {dominios.ciencias_sociales}: </strong>
          {dato.ciencias_sociales} apariciones ({(dato.ciencias_sociales*100/dato.freq).toFixed(2)}%) | 
        </span>);
        if(dato.biologia_cc_salud > 0) totalDominios.push(<span>
          <strong> {dominios.biologia_cc_salud}: </strong>
          {dato.biologia_cc_salud} apariciones ({(dato.biologia_cc_salud*100/dato.freq).toFixed(2)}%) 
        </span>)
    });

    return totalDominios;
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    let sumaTextos = [];

    this.state.textos.map(dato =>{ sumaTextos.push(dato.numero_textos) });

    let sumaText = sumaTextos.reduce((a,b) => a+b,0);

    var type = 'Pie';
    var data = {
      labels: [], 
      series: []
    };
    var options = {
      chartPadding: 30,
      labelOffset: 70,
      labelDirection: 'explode',
      startAngle: 270
    };

    this.state.totales.map(dato => {       
        if(dato.artes_humanidades > 0){ data.series.push(dato.artes_humanidades);
          data.labels.push(dominios.artes_humanidades);}
        if(dato.cc_fisicas > 0) {data.series.push(dato.cc_fisicas);
          data.labels.push(dominios.cc_fisicas);}
        if(dato.ciencias_sociales > 0) {data.series.push(dato.ciencias_sociales);
          data.labels.push(dominios.ciencias_sociales);}
        if(dato.biologia_cc_salud > 0) {data.series.push(dato.biologia_cc_salud);
          data.labels.push(dominios.biologia_cc_salud)}
    });

    return (
      <div>
        {this.state.total === 0 ? (
          <p>No existen datos cuantitativos</p>
        ) : (
          <Card
            id="chartPreferences"
            classes="ct-chart ct-perfect-fourth chart-estadisticas"
            category={
              <p>{this.crearInformacionDominio(dominios)}</p>
            }
            stats={
              <p>
                <strong>Total:</strong> {this.state.total} apariciones en el
                corpus y {(this.state.total/sumaText).toFixed(3)} por artículo
              </p>
            }
            content={
              <div>
                <ChartistGraph data={data} options={options} type={type} />
              </div>
            }
          />
        )}
      </div>
    );
  }
}

export default EstadisticasColocativos;
